// ─── Animation template registry ───────────────────────────────────────────
// Single source of truth for the animation catalogue. Add new templates by
// importing them here and adding them to the map. Anything that needs to
// resolve a `templateId → component` (preview renderer, agent tool, future
// export pipeline) reads from this registry.

import type { AnimationTemplate } from './types';
import { kineticTitleTemplate } from './templates/kineticTitle';
import { lowerThirdTemplate }   from './templates/lowerThird';
import { bigNumberTemplate }    from './templates/bigNumber';
import { badgeStampTemplate }   from './templates/badgeStamp';
import { statsGridTemplate }    from './templates/statsGrid';
import { imageRevealTemplate }  from './templates/imageReveal';
import { progressBarTemplate }  from './templates/progressBar';
import { lottieAssetTemplate }  from './templates/lottieAsset';

export const ANIMATION_TEMPLATES: Record<string, AnimationTemplate<any>> = {
  [kineticTitleTemplate.id]: kineticTitleTemplate,
  [lowerThirdTemplate.id]:   lowerThirdTemplate,
  [bigNumberTemplate.id]:    bigNumberTemplate,
  [badgeStampTemplate.id]:   badgeStampTemplate,
  [statsGridTemplate.id]:    statsGridTemplate,
  [imageRevealTemplate.id]:  imageRevealTemplate,
  [progressBarTemplate.id]:  progressBarTemplate,
  [lottieAssetTemplate.id]:  lottieAssetTemplate,
};

export const ANIMATION_TEMPLATE_LIST: AnimationTemplate<any>[] = Object.values(
  ANIMATION_TEMPLATES,
);

export const getAnimationTemplate = (
  id: string | undefined,
): AnimationTemplate<any> | null => (id ? ANIMATION_TEMPLATES[id] ?? null : null);
